import React from 'react';
import {BasketPageSkeletonDesktop} from '@aboutyou/logic-components';
import {lazy} from '@aboutyou/lazy-imports';

const NewBasketEager = lazy(
  () =>
    import('./BasketPage.eager').then(mod => ({default: mod.BasketPageEager})),
  {
    fallback: <BasketPageSkeletonDesktop />,
    aboveTheFold: true,
  },
);

export const BasketPage = () => {
  return <NewBasketEager />;
};
